import { hooks } from '@atlassian/mpac-utils';
import { useEffect } from 'react';
import { AppListingTask } from "../telemetry/tasks";
const {
  usePrevious
} = hooks;
export const useAppListingTelemetryTracking = (data, error) => {
  const previousData = usePrevious(data);
  useEffect(() => {
    AppListingTask.start();
  }, []);
  useEffect(() => {
    var _error$networkError;

    if (error && ((_error$networkError = error.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.statusCode) !== 401
    /* When the status is 401, we redirect to login instead [MC-1770, MC-2339] */
    ) {
      AppListingTask.failed(error);
    }
  }, [error]);

  if (!previousData && data && !error) {
    AppListingTask.succeeded();
  }
};